/**
 * @generated SignedSource<<15e2a359370a9cec6579ec522485b3a7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment, RefetchableFragment } from 'relay-runtime';
export type controllertype = "C18" | "C78" | "UNKNOWN" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type ControllersList_controllers$data = {
  readonly controllers: {
    readonly __id: string;
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly __id: string;
        readonly controllerId: string;
        readonly controllerRelease: {
          readonly id: string;
          readonly releaseKey: string;
          readonly versionString: string | null;
        } | null;
        readonly controllerType: controllertype;
        readonly id: string;
        readonly name: string | null;
        readonly organization: {
          readonly id: string;
          readonly name: string;
        } | null;
        readonly organizationId: string | null;
        readonly skydioSerial: string | null;
        readonly uuid: string;
      } | null;
    } | null>;
    readonly totalCount: number;
  } | null;
  readonly " $fragmentType": "ControllersList_controllers";
};
export type ControllersList_controllers$key = {
  readonly " $data"?: ControllersList_controllers$data;
  readonly " $fragmentSpreads": FragmentRefs<"ControllersList_controllers">;
};

import ControllersRefetchQuery_graphql from './ControllersRefetchQuery.graphql';

const node: ReaderFragment = (function(){
var v0 = [
  "controllers"
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v3 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__id",
      "storageKey": null
    }
  ]
};
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "controllerReleaseUuid"
    },
    {
      "kind": "RootArgument",
      "name": "controllerTypes"
    },
    {
      "kind": "RootArgument",
      "name": "count"
    },
    {
      "kind": "RootArgument",
      "name": "cursor"
    },
    {
      "kind": "RootArgument",
      "name": "organizationUuid"
    },
    {
      "kind": "RootArgument",
      "name": "searchTerm"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "count",
        "cursor": "cursor",
        "direction": "forward",
        "path": (v0/*: any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "count",
          "cursor": "cursor"
        },
        "backward": null,
        "path": (v0/*: any*/)
      },
      "fragmentPathInResult": [],
      "operation": ControllersRefetchQuery_graphql
    }
  },
  "name": "ControllersList_controllers",
  "selections": [
    {
      "alias": "controllers",
      "args": [
        {
          "kind": "Variable",
          "name": "controllerReleaseUuid",
          "variableName": "controllerReleaseUuid"
        },
        {
          "kind": "Variable",
          "name": "controllerTypes",
          "variableName": "controllerTypes"
        },
        {
          "kind": "Variable",
          "name": "organizationUuid",
          "variableName": "organizationUuid"
        },
        {
          "kind": "Variable",
          "name": "searchTerm",
          "variableName": "searchTerm"
        }
      ],
      "concreteType": "ControllerConnection",
      "kind": "LinkedField",
      "name": "__ControllersList_controllers_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "totalCount",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "ControllerEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Controller",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v1/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "uuid",
                  "storageKey": null
                },
                (v2/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "controllerId",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "controllerType",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "skydioSerial",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "organizationId",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Organization",
                  "kind": "LinkedField",
                  "name": "organization",
                  "plural": false,
                  "selections": [
                    (v1/*: any*/),
                    (v2/*: any*/)
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "ControllerRelease",
                  "kind": "LinkedField",
                  "name": "controllerRelease",
                  "plural": false,
                  "selections": [
                    (v1/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "releaseKey",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "versionString",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                (v3/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        (v3/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};
})();

(node as any).hash = "80a5bc17555805891b9dfe461bf66ee7";

export default node;
